import { Card, Empty, Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { Namespace } from 'enums/namespace.enum';
import { BannerType } from 'enums/banner-type.enum';
import { useFetchNewsQuery } from 'services';

import { NewsItem } from './NewsItem';
import styles from './News.module.scss';
import { Spinner } from '../common/components/Spinner/Spinner';

export const News = () => {
  const { t } = useTranslation(Namespace.News);
  const { data: banners, isFetching } = useFetchNewsQuery();

  const activeBanner = banners?.find((b) => b.isActive);
  const filteredBanners = banners?.filter(
    (b) => !b.isActive && (b.type === BannerType.Info || b.type === BannerType.Warning),
  );

  const banner = activeBanner;
  const isEmpty = !banner && (!filteredBanners || filteredBanners.length < 1);

  return (
    <div className={styles.page}>
      <Card className={styles.header}>{t('news')}</Card>
      <Card className={styles.content}>
        <Flex gap={40} vertical>
          {isFetching && <Spinner />}
          {!isEmpty ? (
            <>
              {banner && (
                <div className={styles.newsCard}>
                  <Typography.Title level={5} className={styles.newsTextContent}>
                    {t('actualNews')}
                  </Typography.Title>
                  <NewsItem banner={banner} />
                </div>
              )}

              {filteredBanners && filteredBanners?.length > 0 && (
                <div>
                  <Typography.Title className={styles.newsTextContent} level={5}>
                    {t('previousNews')}
                  </Typography.Title>
                  <Flex vertical gap="middle" className={styles.newsCard}>
                    {filteredBanners.map((filteredBanner) => (
                      <NewsItem banner={filteredBanner} key={filteredBanner.bannerId} />
                    ))}
                  </Flex>
                </div>
              )}
            </>
          ) : (
            <Card className={styles.newsCard}>
              <Empty description={<Typography.Text>{t('noPosts')}</Typography.Text>} />
            </Card>
          )}
        </Flex>
      </Card>
    </div>
  );
};
